import React from 'react';
import Select from '../../../components/common/validation/fields/Select';
import { classToValidate } from '../../../store/validation';
import { arrayOrArray } from '../../../utils/util';
import EventEmitter from '../../../utils/util/eventEmitter';
import { TApiaApiField } from '../ApiaApiHandler';

export type TOption = {
  label: string;
  value: string;
};

export const apiaApiSelectOptions =
  new (class ApiaApiSelectOptions extends EventEmitter<{
    setOptions: {
      fieldName: string;
      options: TOption[];
    };
  }> {})();

const ApiaApiSelect = (props: TApiaApiField) => {
  const element = React.useMemo(() => props.element, [props.element]);
  const className = React.useMemo(
    () =>
      element.class ? `handler__select ${element.class}` : 'handler__select',
    [element.class],
  );
  const [options, setOptions] = React.useState<TOption[]>(
    arrayOrArray(element.options?.option).map((currOption) => {
      return { value: currOption.value, label: currOption.label };
    }),
  );
  const validationRules = React.useMemo(
    () => ({
      required: element.mandatory,
      ...classToValidate(element.class),
    }),
    [element.class, element.mandatory],
  );

  React.useEffect(() => {
    const unsubscribe = apiaApiSelectOptions.on('setOptions', (ev) => {
      if (ev.fieldName === element.name) setOptions(ev.options);
    });

    return () => {
      unsubscribe();
    };
  }, [element.name]);

  return (
    <Select
      className={className}
      name={element.id || element.name}
      label={element.text}
      title={element.title || element.text}
      initialValue={element.value}
      disabled={element.readonly || element.disabled}
      validationRules={validationRules}
      options={options}
      onChange={element.onChange}
    />
  );
};

export default React.memo(ApiaApiSelect);
